// extracted by mini-css-extract-plugin
export default {"container":"ToolbarSyntaxButton-module__container--F0OB5"};